"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.end.failed': 'Failed to end conversation',
};
